import { Skeleton } from "antd";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
function View() {

  const params                =   useParams();
  const { request }           =   useRequest();
  const [list, setList]       =   useState({});
  const [loading, setLoading] =   useState(false);

  const fetchData = (slug) => {
    request({
      url       :   `${apiPath.commonCms}?slug=${slug}`,
      method    :   'GET',
      onSuccess :   (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchData(params.slug)
  }, [])

  return (
    <>
      {loading ? <Skeleton active /> : 
        <div className="p-25">
          <p dangerouslySetInnerHTML={{ __html: list?.description ? list.description : '' }}></p>
        </div>
      }
    </>
  );
}

export default View;
